import React from "react";

/**
 * Animus HUD background for page heroes — mesh, sweep beam, telemetry columns.
 */
export default function AnimusHeroChrome() {
  return (
    <div className="animus-hero-chrome" aria-hidden="true">
      <div className="animus-hero-chrome__mesh" />
      <div className="animus-hero-chrome__sweep" />
      <div className="animus-hero-chrome__bracket animus-hero-chrome__bracket--tl" />
      <div className="animus-hero-chrome__bracket animus-hero-chrome__bracket--br" />
      <div className="animus-hero-chrome__telemetry">
        {Array.from({ length: 12 }, (_, i) => (
          <span
            key={i}
            className="animus-hero-chrome__tick"
            style={{ animationDelay: `${i * 0.35}s` }}
          />
        ))}
      </div>
    </div>
  );
}
